import { render, staticRenderFns } from "./SectionsAdministrationEdit.vue?vue&type=template&id=68905c26&"
import script from "./SectionsAdministrationEdit.vue?vue&type=script&lang=js&"
export * from "./SectionsAdministrationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports